// extracted by mini-css-extract-plugin
export default {"card":"Character_card__Yeffq","img":"Character_img__2hHok"};